import React from "react";

import GridContainer from "../../mui-components/Grid/GridContainer";
import ItemGrid from "../../mui-components/Grid/GridItem";
import RegularCard from "../../mui-components/Card/RegularCard";
import PositionsTable from "../../containers/domain/position/PositionsTable";

const PositionsListingView = () => (
  <GridContainer>
    <ItemGrid xs={12}>
      <RegularCard title="Lista de Posições" content={<PositionsTable />} />
    </ItemGrid>
  </GridContainer>
);

export default PositionsListingView;
